// extracted by mini-css-extract-plugin
export default {"buttons-row":"projectpopup_buttons-row__6TH03","submit-btn":"projectpopup_submit-btn__4rArh","cancel-btn":"projectpopup_cancel-btn__ZzI+d"};